import { Link } from 'react-router-dom'
import { ExternalLink } from 'lucide-react'
import { DENOMINATION_OPTIONS } from '@fellowship/shared'
import type { User } from '@fellowship/shared'
import { Avatar } from '../ui/Avatar'

const DENOM_LABEL: Record<string, string> = Object.fromEntries(
  DENOMINATION_OPTIONS.map((d) => [d.key, d.label]),
)

interface AccountHeaderProps {
  user: User
  onEdit: () => void
}

export function AccountHeader({ user, onEdit }: AccountHeaderProps) {
  const subtitle = [
    user.locationLabel,
    user.denomination ? DENOM_LABEL[user.denomination] ?? user.denomination : null,
  ]
    .filter(Boolean)
    .join(' · ')

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
      <Avatar
        name={user.displayName}
        src={user.avatarUrl}
        size={60}
        style={{ boxShadow: '0 0 0 2px var(--bg), 0 0 0 4px var(--primary)' }}
      />
      <div style={{ minWidth: 0 }}>
        <div style={{ fontSize: 26, fontWeight: 600, letterSpacing: '-0.02em', color: 'var(--ink)' }}>
          {user.displayName}
        </div>
        {subtitle && <div style={{ fontSize: 13.5, color: 'var(--muted)', marginTop: 2 }}>{subtitle}</div>}
      </div>
      <div style={{ marginLeft: 'auto', display: 'flex', gap: 10, alignItems: 'center', flexShrink: 0 }}>
        {user.profilePublic && (
          <Link
            to={`/hosts/${user.id}`}
            style={{
              fontSize: 13,
              color: 'var(--muted)',
              textDecoration: 'none',
              display: 'inline-flex',
              alignItems: 'center',
              gap: 4,
            }}
          >
            View public profile <ExternalLink size={12} strokeWidth={2} />
          </Link>
        )}
        <button
          type="button"
          onClick={onEdit}
          style={{
            background: 'var(--surface)',
            color: 'var(--ink)',
            border: '1px solid var(--line-soft)',
            borderRadius: 999,
            padding: '9px 18px',
            fontSize: 13.5,
            fontWeight: 600,
            fontFamily: 'inherit',
            cursor: 'pointer',
          }}
        >
          Edit profile
        </button>
      </div>
    </div>
  )
}
